import { Verified } from "./verified";
import { VerifiedUser } from "./verified_user";
import { VideoCameraFront } from "./video_camera_front";
import { Visibility } from "./visibility";
import { VolunteerActivism } from "./volunteer_activism";
import { VpnKey } from "./vpn_key";

const iconsList = [
  { label: "Verified", code: <Verified /> },
  { label: "VerifiedUser", code: <VerifiedUser /> },
  { label: "VideoCameraFront", code: <VideoCameraFront /> },
  { label: "Visibility", code: <Visibility /> },
  { label: "VolunteerActivism", code: <VolunteerActivism /> },
  { label: "VpnKey", code: <VpnKey /> },
];

export {
  iconsList,
  Verified,
  VerifiedUser,
  VideoCameraFront,
  Visibility,
  VolunteerActivism,
  VpnKey,
};
